var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.speakAlarm)?_c('div',{staticClass:"alarm-notify-container",on:{"click":_vm.showAlarmWin}},[_c('Icon',{staticClass:"alarm-notify-icon",attrs:{"type":"md-call"}}),_c('div',{staticClass:"alarm-showing"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }